import * as Sentry from '@sentry/react';
import type { Router } from '@tanstack/react-router';

import { config } from '@/config/config';
import type { routeTree } from '@/routeTree.gen';

export const initSentry = (router: Router<typeof routeTree>) => {
	if (!config.enableSentry) {
		return;
	}

	Sentry.init({
		dsn: config.sentryDsn,
		integrations: [Sentry.tanstackRouterBrowserTracingIntegration(router)],
		tracesSampleRate: config.sentryTracesSampleRate,
		tracePropagationTargets: [config.apiUrl],
		environment: config.environment,
		release: `a6tr-backoffice@${__APP_VERSION__.replace(/^v(?=\d)/, '')}`,
		initialScope: { tags: { app: 'backoffice' } },
		sendDefaultPii: false,
	});
};
